import type { EnrollmentScreen, Requirements } from "./types";
import { isSatisfiedCollector } from "./screen";

/**
 * Completed collector screens before the entry screen, used to seed the back stack at mount
 * so "back" can reach steps already finished (e.g. a pre-filled address). Only satisfied
 * collectors — a screen the enrollment never needed (e.g. `ssn` after a passing credit
 * check) isn't one the customer can back into.
 */
export function precedingCompletedScreens(
  screens: EnrollmentScreen[],
  entryPath: string,
  requirements: Requirements,
): string[] {
  const end = screens.findIndex((screen) => screen.path === entryPath);
  const upto = end < 0 ? screens.length : end;
  return screens
    .slice(0, upto)
    .filter((screen) => isSatisfiedCollector(screen, requirements))
    .map((screen) => screen.path);
}
